import React from "react";
import "./ImpactLegend.css";

const fmt = (n, d = 0) =>
  Number(n ?? 0).toLocaleString("fr-FR", { maximumFractionDigits: d });

const ToggleRow = ({ swatch, label, value, tone, active, onToggle }) => (
  <button
    type="button"
    className={`il-row il-row--toggle ${active ? "" : "is-off"}`}
    aria-pressed={active}
    onClick={onToggle}
    title={active ? "Masquer sur la carte" : "Afficher sur la carte"}
  >
    <span className="il-row__label">
      <i className={`il-swatch ${swatch}`} />
      {label}
    </span>
    {value != null && <b className={`il-row__value ${tone}`}>{value}</b>}
  </button>
);

const ImpactLegend = ({
  results,
  realArea,
  simArea,
  visible,
  onToggle,
  showAreas = true,
}) => {
  if (!results) return null;
  const { zones, buildings } = results;

  return (
    <div className="il" role="group" aria-label="Légende de l’analyse">
      <h4>Légende</h4>

      <ToggleRow
        swatch="il-swatch--real"
        label="Polygone sinistré"
        value={showAreas && realArea != null ? `${fmt(realArea, 1)} ha` : null}
        tone="il-tone--burgundy"
        active={visible.real}
        onToggle={() => onToggle("real")}
      />
      <ToggleRow
        swatch="il-swatch--sim"
        label="Polygone menacé"
        value={showAreas && simArea != null ? `${fmt(simArea, 1)} ha` : null}
        tone="il-tone--purple"
        active={visible.sim}
        onToggle={() => onToggle("sim")}
      />
      <ToggleRow
        swatch="il-swatch--zone"
        label="Zone sauvegardée"
        value={
          showAreas && zones?.preserve?.area_ha != null
            ? `${fmt(zones.preserve.area_ha, 1)} ha`
            : null
        }
        tone="il-tone--green"
        active={visible.zone}
        onToggle={() => onToggle("zone")}
      />

      <div className="il-buildings">
        <ToggleRow
          swatch="il-dot il-dot--burned"
          label={`Bâti touché (${fmt(buildings.sinistre.count)})`}
          active={visible.burned}
          onToggle={() => onToggle("burned")}
        />
        <ToggleRow
          swatch="il-dot il-dot--saved"
          label={`Bâti sauvé (${fmt(buildings.preserve.count)})`}
          active={visible.saved}
          onToggle={() => onToggle("saved")}
        />
      </div>
    </div>
  );
};

export default ImpactLegend;
